var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalBase',{attrs:{"title":_vm.dispTitle,"isShowModal":_vm.isShowModal,"canCancel":false,"close":_vm.modalClose,"width":'550px',"height":'200px'}},[_c('div',{staticClass:"card -card"},[_c('b-message',{attrs:{"type":"is-info","has-icon":""}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.dispMessage)}}),_vm._v(" "),_c('span',{staticClass:"mdi mdi-loading mdi-spin"})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-983b94d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/hrm-frontend/views/atomic/screen-components/purpose_components/common-components/LoadingModal.vue
// module id = null
// module chunks = 